export function useEmbeddedLayout(): boolean {
  return (
    new URLSearchParams(window.location.search).get("renderMobile") === "true"
  );
}
